import type { Example } from "../types";
import code from "./code.js" with { type: "text" };
import golden from "./golden.json";

export const stringBuiltFetch: Example = {
  id: "string-built-fetch",
  title: "String-built fetch",
  group: "technique",
  environment: "browser",
  mode: "script",
  summary: "Calls fetch through a name assembled at runtime",
  explainer:
    "The source never mentions `fetch` or the destination, so static scanners miss it. " +
    "Running it reveals a POST to metrics-cdn.example in the Timeline.",
  code,
  expect: golden as Example["expect"],
};
